/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { Component, ElementRef, inject, OnDestroy, OnInit, Renderer2 } from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';
import { ZIndexUtils } from 'primeng/utils';

import { RoutedOutletService } from '@irian-ro/navigation-module';
import { BsButtonDirective, BsButtonIconDirective } from '@well/iriro-frontend-libs/bs-component-store';

@Component({
    selector: 'well-route-popup-full',
    templateUrl: './route-popup-full.component.html',
    styleUrls: ['./route-popup-full.component.scss'],
    imports: [BsButtonDirective, BsButtonIconDirective, RouterOutlet]
})
export class RoutePopupFullComponent implements OnDestroy, OnInit {
  private router = inject(Router);
  private renderer = inject(Renderer2);
  private elementRef = inject(ElementRef);

  private routedOutletService = inject(RoutedOutletService);

  constructor() {
    this.renderer.addClass(document.body, 'popup-full-outlet');
  }

  public close(): void {
    this.router.navigate([{ outlets: { 'popup-full': null } }], {
      queryParamsHandling: 'merge',
    });
  }

  ngOnDestroy(): void {
    this.renderer.removeClass(document.body, 'popup-full-outlet');
    this.routedOutletService.resolve('popup-full');
  }

  ngOnInit(): void {
    ZIndexUtils.set('modal', this.elementRef.nativeElement, 1000);
  }
}
